import PropTypes from "prop-types";

import ReadAloudSpans from "@/view/ReadAloudControls/ReadAloudSpans";
import useReadAloudMode from "@/view/ReadAloudControls/useReadAloudMode";
import {
  valueCss,
  rowCss,
  labelCss,
  itemCss,
} from "./ContentDisplayDetailsRow.style";

const propTypes = {
  row: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.node,
    }),
  ),
};

const renderLabel = (item, isReadAloudModeActive) => {
  if (isReadAloudModeActive && item.shouldBeReadAloud) {
    return <ReadAloudSpans startOffsetRelativeToParent={0} text={item.label} />;
  }

  return item.label;
};

const renderValue = (item, isReadAloudModeActive) => {
  if (isReadAloudModeActive && item.shouldBeReadAloud) {
    return (
      <ReadAloudSpans
        // Adds an additional character to account for the space before the value.
        startOffsetRelativeToParent={item?.label?.length + 1 || 0}
        text={item.value}
      />
    );
  }

  return item.value;
};
const ContentDisplayDetailsRow = ({ row }) => {
  const { isReadAloudModeActive, readAloudSpanRefs } = useReadAloudMode();

  return (
    <p css={rowCss}>
      {row.map((item) => (
        <div
          key={item.label}
          css={itemCss}
          ref={(ref) => {
            if (ref && item.shouldBeReadAloud) {
              readAloudSpanRefs.current[item.readAloudIdentifier] = ref;
            }
          }}
        >
          {item.hideLabel ? null : (
            <span css={labelCss}>
              {renderLabel(item, isReadAloudModeActive)}
            </span>
          )}
          <span css={valueCss}>{renderValue(item, isReadAloudModeActive)}</span>
        </div>
      ))}
    </p>
  );
};

const Unauth = ({ row }) => {
  return (
    <p css={rowCss}>
      {row.map((item) => (
        <div key={item.label} css={itemCss}>
          {item.hideLabel ? null : <span css={labelCss}>{item.label}</span>}
          <span css={valueCss}>{item.value}</span>
        </div>
      ))}
    </p>
  );
};

ContentDisplayDetailsRow.propTypes = propTypes;
Unauth.propTypes = propTypes;

ContentDisplayDetailsRow.Unauth = Unauth;

export default ContentDisplayDetailsRow;
